/* eslint-disable */
import { useEffect } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Select from "react-select";
import { Field, useFormState } from "react-final-form";
import useCustomerHook from "../../../customers/useCustomerHook";
import DatePicker from "react-datepicker";

const required = (value) => (value ? undefined : "This field is required");

const BasicInvoiceDetailsForm = ({ status }) => {
  const { customers } = useCustomerHook();
  const { values } = useFormState();
  const formattedOptions = (options) =>
    options?.map((option) => ({
      value: option.id,
      label: option?.user?.full_name,
      data: option,
    }));

  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("w-100"));
  }, []);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form-group-item border-0 mb-0">
          <div className="row align-item-center">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>
                  Customer <span className="text-danger">*</span>
                </label>
                <ul className="form-group-plus css-equal-heights">
                  <li>
                    <Field name="customer" validate={required}>
                      {({ input, meta }) => {
                        // Find the customer object from id if input.value is an id
                        let selectedOption = null;
                        const options = formattedOptions(customers);
                        if (typeof input.value === "string") {
                          selectedOption =
                            options?.find((opt) => opt.value === input.value) ||
                            null;
                        } else {
                          selectedOption = input.value;
                        }
                        return (
                          <div>
                            <Select
                              {...input}
                              value={selectedOption}
                              onChange={input.onChange}
                              options={options}
                              placeholder="Choose Customer"
                            />
                            {meta.error && meta.touched && (
                              <span className="text-danger">{meta.error}</span>
                            )}
                          </div>
                        );
                      }}
                    </Field>
                  </li>
                  <li>
                    <Link
                      className="btn btn-primary form-plus-btn"
                      to="/customers/add-customer"
                    >
                      <FeatherIcon icon="plus-circle" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>
                  Proforma Date <span className="text-danger">*</span>
                </label>
                <div className="cal-icon cal-icon-info">
                  <Field name="proforma_date" validate={required}>
                    {({ input, meta }) => (
                      <div>
                        <DatePicker
                          className="datetimepicker form-control"
                          selected={input.value}
                          onChange={input.onChange}
                          dateFormat="dd/MM/yyyy"
                        />
                        {meta.error && meta.touched && (
                          <span className="text-danger">{meta.error}</span>
                        )}
                      </div>
                    )}
                  </Field>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>
                  Expiry Date <span className="text-danger">*</span>
                </label>
                <div className="cal-icon cal-icon-info">
                  <Field name="expiry_date" validate={required}>
                    {({ input, meta }) => (
                      <div>
                        <DatePicker
                          className="datetimepicker form-control"
                          selected={input.value}
                          onChange={input.onChange}
                          dateFormat="dd/MM/yyyy"
                        />
                        {meta.error && meta.touched && (
                          <span className="text-danger">{meta.error}</span>
                        )}
                      </div>
                    )}
                  </Field>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>
                  Subject 
                </label>
                <Field name="subject" >
                  {({ input, meta }) => (
                    <div>
                      <input
                        {...input}
                        type="text"
                        className="form-control"
                        placeholder="Enter Subject"
                      />
                      {meta.error && meta.touched && (
                        <span className="text-danger">{meta.error}</span>
                      )}
                    </div>
                  )}
                </Field>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>Reference Number </label>
                <Field name="reference">
                  {({ input, meta }) => (
                    <div>
                      <input
                        {...input}
                        type="text"
                        className="form-control"
                        placeholder="Enter Reference Number"
                      />
                      {meta.error && meta.touched && (
                        <span className="text-danger">{meta.error}</span>
                      )}
                    </div>
                  )}
                </Field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInvoiceDetailsForm;
